module.exports = __webpack_public_path__ + "static/media/feature_pict_4.d18241af.svg";